export default __webpack_public_path__ + "static/media/user-icon.3d6e2547.svg";